import { ApiService } from '~/services';

export default ({ app: { $axios } }, inject) => {
  // pass $axios as a dependency to the api service constructor
  const service = new ApiService($axios);

  // inject the service, making it available in the context, component, store, etc.
  inject('api', service);
};
